import Geolocation from "./Geolocation";

export default Geolocation;
